import type { ActorRefFrom } from 'xstate'
import type { mapTooltipMachine } from '~/machines/mapTooltipMachine'

type MapTooltipActor = Pick<ActorRefFrom<typeof mapTooltipMachine>, 'send'>

let actor: MapTooltipActor | null = null

export function registerMapTooltipActor(ref: MapTooltipActor) {
  actor = ref
  return () => {
    actor = null
  }
}

export function notifyAdaptationChanged() {
  actor?.send({ type: 'ADAPTATION_CHANGED' })
}
